import { useLocation } from "react-router-dom";

const useQuery = () => {
  const searchQuery = new URLSearchParams(useLocation().search);

  let obj: string[] = [];
  let name: string | null = "";
  let page = searchQuery.get("page") || "0";

  for (var key of searchQuery.keys()) {
    if (key === "name" || key === "category" || key === "location") {
      name = searchQuery.get(key);
    }

    if (key) obj.push(`${key}=${searchQuery.get(key)}`);
  }

  return { result: obj.join("&"), name, page: parseInt(page) };
};

export default useQuery;
